import React from 'react';
import { GridResults } from '../components';

const SectionReviewModals = ({content}) => {

  return (
    <>
      <h3 className='section-title mb-50 mt-90' dangerouslySetInnerHTML={{ __html: content.title }} />
      <GridResults link={{ label: content.buttonText, to: content.buttonUrl  }} pictures={content.reviews} trustpilot={content.trustpilot} slide hasAction className='mb-90' />
    </>
  )
}

export default SectionReviewModals;